export enum AffordabilityMet {
  Yes = 'Yes',
  No = 'No',
  Unknown = 'Unknown',
}
